import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { verifyEmailOtpPost } from '../../../../api-client/api-svcpp-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postVerifyEmailOtp = createAsyncThunk(
    'postVerifyEmailOtp/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await verifyEmailOtpPost(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_VERIFY_EMAIL_OTP_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postVerifyEmailOtpSlice = createSlice({
    name: 'postVerifyEmailOtp',
    initialState,
    extraReducers: {
        [postVerifyEmailOtp.pending]: (state) => {
            state.loading = true;
        },
        [postVerifyEmailOtp.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload;
        },
        [postVerifyEmailOtp.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postVerifyEmailOtpSelector = (state) => state.postVerifyEmailOtp;
export const postVerifyEmailOtpReducer = postVerifyEmailOtpSlice.reducer;
